export default "<div class=\"loading-overlay\" [hidden]=\"!loading\">\n    <div><mat-spinner color=\"primary\">Loading...</mat-spinner></div>\n</div>"